// extracted by mini-css-extract-plugin
export default {"button":"styles_button__ARIEW","primary":"styles_primary__hUDJn","disabled":"styles_disabled__Vz9H9"};